import { render } from "./CommercialBookingType.vue?vue&type=template&id=7202878e"
import script from "./CommercialBookingType.vue?vue&type=script&lang=js"
export * from "./CommercialBookingType.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__